import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { ColumnDef, OrderModel } from "../../models/orders/order-list-model";
import { Column } from "primereact/column";

interface DataTableProps {
  data: any[];
}

const CashCollectionListDataTable: React.FC<DataTableProps> = ({ data }) => {
  const [orderDataList, setOrderDataList] = useState<OrderModel[]>(data);

  useEffect(() => {
    setOrderDataList(data);
  },[data]);


  const columns: ColumnDef[] = [
        {
      field: "invoiceDate",
      header: "Date",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
      new Date(row.invoiceDate).toLocaleDateString("en-gb", {
          day: "2-digit",
          month: "short",
          year: "numeric",
      }),
    },
    {
      field: "totalSales",
      header: "Total Sales",
      style: { minWidth: "7rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.totalSales).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
    {
      field: "cashAmount",
      header: "Cash",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.cashAmount).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
      {
      field: "paymentAmount",
      header: "Online",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.paymentAmount).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
          {
      field: "credit",
      header: "Credit",
      style: { minWidth: "9rem" },
      sortable:true,
      cell: (row: any) =>
        Math.round(row.credit).toLocaleString("en-gb", {
          style: "currency",
          currency: "INR",
        }),
    },
  ];



  return (
    <>
      <div className="col-12 card border-noround p-2">
        {orderDataList !== null ?<DataTable
            value={orderDataList}
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            stripedRows
            showGridlines
            sortMode="multiple"
            emptyMessage="No Record found."
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          >
            {columns.map((col, i) => (
              <Column
                key={i}
                field={col.field}
                header={col.header}
                sortable={col.sortable}
                style={col.style}
                body={col.cell}
              />
            ))}
          </DataTable> : ""}
      </div>
    </>
  );
};

export default CashCollectionListDataTable;